import { GroupingOptionsV2 } from '@vae/server/src/utils/arrays/types/GroupingOptions'
import { useContext } from 'react'
import { UserContext } from '../../../../../contexts/UserContext'
import { trpc } from '../../../../../modules/trpc'

export interface DatasetOptions {
	id:
		| 'exchangePrices'
		| 'transfer'
		| 'production-sold'
		| 'production-used'
		| 'consumption'
		| 'breakdown'
	data: number[] | string[]
	label: string
	backgroundColor?: string | string[]
	yAxisID: ChartDataId
	hidden?: boolean
	optional?: {
		transferPricePerKwh?: number
		transferPrices?: number[]
		pricesWithMargin?: number[]
	}
}

export type ChartDataId = 'mainData' | 'embeddedPrice' | 'transferprices'

export type ChartDataHook = ReturnType<typeof useConsumptionChartData>

interface useConsumptionChartDataProps {
	objectId: number
	from: string
	to: string
	grouping: GroupingOptionsV2
	useQuarterHourlyPrices: boolean
}

export const useConsumptionChartData = (input: useConsumptionChartDataProps) => {
	const { from, to } = input
	const { isAnonymousUser, isUserContextLoading } = useContext(UserContext)

	const { data, isFetching, refetch } = trpc.charts.get.useQuery(
		{
			...input,
		},
		{
			enabled: !!from && !!to && !isAnonymousUser && !isUserContextLoading && input.objectId !== 0,
		}
	)

	return {
		data,
		isLoading: isFetching,
		refetch,
	}
}
